import {
  CertificadoRecebiveisApiResponse,
  GETInstrumentosFilterParams,
  CadastroCertificadoRecebiveisApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETCertificadoRecebiveisDetalhes,
  GETCertificadosRecebiveis,
  POSTCertificadoRecebiveis,
  PUTCertificadoRecebiveis,
  GETCertificadoRecebiveisDocumentDownloadUrl,
  POSTInterOpCertificadoRecebiveis,
  POSTEnviarLiquidacao,
  GETHistoricoCertificadoRecebiveis,
  POSTConfirmarLiquidacaoCertificadoRecebiveis,
  PUTUploadDoc,
  DELETEUploadDoc,
  GETCertificadoRecebiveisByInstrumentoId,
  PUTCertificadoRecebiveisAditamento,
  PutEditarCertificadoRecebiveis,
  GETAditamentoCertificadoRecebiveis,
  PUTAditamentoCertificadoRecebiveis,
} from 'requests/certificadoRecebiveis';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface CertificadoRecebiveisApiState {
  getCertificadoRecebiveisDetalhes(
    dispatch: Dispatch,
    id: string,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  getCertificadosRecebiveis(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CertificadoRecebiveisApiResponse>>;
  getCertificadoRecebiveisByInstrumentoId(
    dispatch: Dispatch,
    instrumentoId: string,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  postCertificadoRecebiveis(
    dispatch: Dispatch,
    certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  putCertificadoRecebiveis(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  putEditarCertificadoRecebiveis(
    dispatch: Dispatch,
    crId: string,
    cr: CadastroCertificadoRecebiveisApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putCertificadoRecebiveisAditamento(
    dispatch: Dispatch,
    crId: string,
    cr: CadastroCertificadoRecebiveisApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putUploadDoc(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    certificadoRecebiveisDocumentId: string,
    stackRequest?: boolean
  ): Promise<unknown>;
  getCertificadoRecebiveisDocumentDownloadUrl(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    certificadoRecebiveisDocumentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postInterOpCertificadoRecebiveis(
    dispatch: Dispatch,
    certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    certificadoRecebiveisSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  postConfirmarLiquidacaoCertificadoRecebiveis(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    precoUnitarioLiquidacao: number,
    stackRequest?: boolean
  ): Promise<CertificadoRecebiveisApiResponse>;
  getHistoricoCertificadoRecebiveis(
    dispatch: Dispatch,
    certificadoRecebiveisId: string,
    stackRequest?: boolean
  ): Promise<Array<HistoricoResponse>>;
  getAditamentoCertificadoRecebiveis(
    dispatch: Dispatch,
    aditamentoId: string,
    stackRequest?: boolean
  ): Promise<AditamentoRevisionData>;
  putAditamentoCertificadoRecebiveis(dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest?: boolean): Promise<Array<AditamentoDiferenca>>;
}

export const certificadoRecebiveisApiInicialState: CertificadoRecebiveisApiState = {
  getCertificadoRecebiveisDetalhes: GETCertificadoRecebiveisDetalhes,
  getCertificadosRecebiveis: GETCertificadosRecebiveis,
  getCertificadoRecebiveisByInstrumentoId: GETCertificadoRecebiveisByInstrumentoId,
  postCertificadoRecebiveis: POSTCertificadoRecebiveis,
  putCertificadoRecebiveis: PUTCertificadoRecebiveis,
  putEditarCertificadoRecebiveis: PutEditarCertificadoRecebiveis,
  putCertificadoRecebiveisAditamento: PUTCertificadoRecebiveisAditamento,
  putUploadDoc: PUTUploadDoc,
  deleteUploadDoc: DELETEUploadDoc,
  getCertificadoRecebiveisDocumentDownloadUrl: GETCertificadoRecebiveisDocumentDownloadUrl,
  postInterOpCertificadoRecebiveis: POSTInterOpCertificadoRecebiveis,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoCertificadoRecebiveis: POSTConfirmarLiquidacaoCertificadoRecebiveis,
  getHistoricoCertificadoRecebiveis: GETHistoricoCertificadoRecebiveis,
  getAditamentoCertificadoRecebiveis: GETAditamentoCertificadoRecebiveis,
  putAditamentoCertificadoRecebiveis: PUTAditamentoCertificadoRecebiveis,
};

enum CertificadoRecebiveisApiActionType {
  Update = 'certificadoRecebiveisApi/UPDATE',
  Reset = 'certificadoRecebiveisApi/RESET',
}

export const updateCertificadoRecebiveisApi = (state: CertificadoRecebiveisApiState) => {
  return typedAction(CertificadoRecebiveisApiActionType.Update, state);
};

export const resetCertificadoRecebiveisApi = () => {
  return typedAction(CertificadoRecebiveisApiActionType.Reset);
};

type CertificadoRecebiveisApiAction = ReturnType<
  typeof updateCertificadoRecebiveisApi | typeof resetCertificadoRecebiveisApi
>;

export function certificadoRecebiveisApiReducer(
  state: CertificadoRecebiveisApiState = certificadoRecebiveisApiInicialState,
  action: CertificadoRecebiveisApiAction
): CertificadoRecebiveisApiState {
  switch (action.type) {
    case CertificadoRecebiveisApiActionType.Update:
      return { ...action.payload };
    case CertificadoRecebiveisApiActionType.Reset:
      return { ...certificadoRecebiveisApiInicialState };
    default:
      return state;
  }
}
